import React from "react";
import videoc from "../../assets/video/pc.mp4";


function Tutorial({data}) {

    return (
        <>
            <section className="relative bg-black mb-40">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none"
                     className="absolute bottom-0 left-0 w-full h-[162px] translate-y-full">
                    <path d="M761.9,44.1L643.1,27.2L333.8,98L0,3.8V0l1000,0v3.9"></path>
                </svg>
                <div className="container px-5 py-10 md:pt-20 md:pb-0">
                    <div className="text-center mb-10"><h6 className="uppercase text-primari">Instalación</h6>
                        <h2 className="mt-3 uppercase text-[26px] md:text-[30px] leading-[1.1em] font-bold">
                            Cómo instalar Stella TV en PC & Mac
                        </h2>
                        <p className="mt-3 max-w-2xl mx-auto text-white">
                            <span className="text-[#ff6600] font-bold">Método1:</span>La instalación de Stella TV la
                            vamos a realizar con emuladores Android. (compatible con Windows y Mac OS)

                        </p></div>
                    <div className="grid md:grid-cols-2 gap-6 mt-10 md:p-10">
                        <div className="intersect:animate-in slide-in-from-top intersect-once duration-1250">
                            <div><h4
                                className="relative z-1 p-2.5 md:px-[25px] md:py-5 md:w-max font-bold uppercase border border-bottom-0 border-white text-[#F9AA02] bg-black mb-0">PASO
                                1</h4>
                                <div className="relative md:-top-[2px] p-2.5 md:p-5 leading-relaxed border text-white">El primer
                                    paso es <span className="text-[#ff6600]">descargar el emulador BlueStacks</span> en
                                    tu PC, compatible con Windows y macOS. Luego, procede a instalarlo; el tiempo de
                                    instalación puede variar según el rendimiento de tu computadora.
                                </div>
                            </div>
                        </div>
                        <div className="intersect:animate-in slide-in-from-top intersect-once duration-1250">
                            <div><h4
                                className="relative z-1 p-2.5 md:px-[25px] md:py-5 md:w-max font-bold uppercase border border-bottom-0 border-white text-[#F9AA02] bg-black mb-0">PASO
                                2</h4>
                                <div className="relative md:-top-[2px] p-2.5 md:p-5 leading-relaxed border text-white">Una vez
                                    instalado el emulador Android, ábrelo y, si te solicita iniciar sesión con una
                                    cuenta de Gmail, hazlo para completar la configuración. (Si tienes problemas con
                                    BlueStacks, puedes optar por usar Nox Player)
                                </div>
                            </div>
                        </div>
                        <div className="intersect:animate-in slide-in-from-top intersect-once duration-1250">
                            <div><h4
                                className="relative z-1 p-2.5 md:px-[25px] md:py-5 md:w-max font-bold uppercase border border-bottom-0 border-white text-[#F9AA02] bg-black mb-0">PASO
                                3</h4>
                                <div className="relative md:-top-[2px] p-2.5 md:p-5 leading-relaxed border text-white">En este
                                    paso, abre el navegador Google Chrome que viene preinstalado en el emulador y
                                    escribe el siguiente enlace: <span
                                        className="text-[#ff6600] font-bold">{data.link}</span>
                                </div>
                            </div>
                        </div>
                        <div className="intersect:animate-in slide-in-from-top intersect-once duration-1250">
                            <div><h4
                                className="relative z-1 p-2.5 md:px-[25px] md:py-5 md:w-max font-bold uppercase border border-bottom-0 border-white text-[#F9AA02] bg-black mb-0">PASO
                                4</h4>
                                <div className="relative md:-top-[2px] p-2.5 md:p-5 leading-relaxed border text-white">Por último,
                                    espera a que se descargue la aplicación y procede a instalarla en el emulador.
                                    ¡Listo! Solo queda iniciar sesión en Stella TV.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-8 mx-auto text-center text-white"><p className="leading-relaxed"><span
                        className="text-[#ff6600] font-bold">NOTA:</span> Si tiene algún problema con uno de los emuladores puede eliminarlo y probar otro.</p></div>
                    <div className="mt-10 flex justify-center">
                        <div className="w-full md:w-[60%]"><h4
                            className="text-2xl font-semibold uppercase text-center mb-5">VIDEO TUTORIAL - GUÍA</h4>
                            <video className="w-full rounded-[10px] h-[400px]"
                                   src={videoc}
                                   controls
                                   controlsList="nodownload">Video tutorial de instalación de Stella TV
                            </video>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Tutorial;
